import { createContext, useContext } from 'react';
// added any to list here because enums were causing errors
// - would be great to fix underlying issue.
const StoreContext = createContext(null);
export const StoreProvider = StoreContext.Provider;
export const useStore = () => {
    const store = useContext(StoreContext);
    if (!store) {
        // airbrake.notify('Store cannot be null');
        throw new Error('Store cannot be null, please add a context provider.');
    }
    return store;
};
//# sourceMappingURL=StoreProvider.js.map